
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["iconify iconify--iconoir",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.5 15.5L19 19M5 11a6 6 0 1012 0 6 6 0 00-12 0z"}})])])
          )
        }
      }
    